export default "__VITE_ASSET__CO6Q2hnY__"